import { withExtraArgument } from 'redux-thunk';
import actionDebugger from '@shoflo/studio-redux/middleware/actionDebugger/actionDebugger';
import apiMiddleware from '@shoflo/studio-redux/middleware/api/api';
import attendeeRosterEmitter from '@shoflo/studio-redux/middleware/attendee/attendeeRosterEmitter';
import toggleBackgroundHiddenMiddleware from '@shoflo/studio-redux/middleware/background/toggleBackgroundHiddenMiddleware';
import dataDogMiddleware from '@shoflo/studio-redux/middleware/dataDog/dataDog';
import { rejectedKnockMiddleware } from '@shoflo/studio-redux/middleware/knock/rejectedKnock';
import { notification } from '@shoflo/studio-redux/middleware/notification/notification';
import notifyDirectors from '@shoflo/studio-redux/middleware/notifyDirectors/notifyDirectors';
import presentationControlNotifier from '@shoflo/studio-redux/middleware/presentationControlNotifier/presentationControlNotifier';
import programEmitter from '@shoflo/studio-redux/middleware/program/programEmitter';
import programSceneLayerUpdater from '@shoflo/studio-redux/middleware/program/programSceneLayerUpdater';
import updateSourceChangesToProgram from '@shoflo/studio-redux/middleware/program/updateSourceChangesToProgram';
import updateProgramLayers from '@shoflo/studio-redux/middleware/program/updateProgramLayers';
import sessionStateEmitter from '@shoflo/studio-redux/middleware/sessionStateEmitter/sessionStateEmitter';
import showAPIError from '@shoflo/studio-redux/middleware/showAPIError/showAPIError';
import sourceUpdateStatusManager from '@shoflo/studio-redux/middleware/sources/sourceUpdateStatusManager/sourceUpdateStatusManager';
import streamRecordStatus from '@shoflo/studio-redux/middleware/streamRecordStatus/streamRecordStatus';
import { getEnvVar } from '@shoflo/polymer/utils/getEnvVar';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { createStore, applyMiddleware, compose } from 'redux';

import acceptedKnockMiddleware from 'middleware/knock/acceptedKnock';
import createdBackgroundMiddleware from 'middleware/background/createBackground/createBackground';
import updateBackgroundOnProgramStartMiddleware from 'middleware/background/updateBackgroundOnProgramStart';
import localNotifyDirectors from 'middleware/notifyDirectors/notifyDirectors';
import createRootReducer from 'reducers';
import setProgram from 'actions/program/setProgram';
import SocketDispatcher from './SocketDispatcher/SocketDispatcher';

function createConfiguredStore() {
  const socketDispatcher = new SocketDispatcher();
  const socket = socketDispatcher.connect();

  const history = createBrowserHistory();

  const initialState = {};

  const enhancers = [];

  const middleware = [
    withExtraArgument(socket),
    routerMiddleware(history),
    apiMiddleware,
    localNotifyDirectors(socket),
    notifyDirectors(socket),
    acceptedKnockMiddleware(socket),
    programEmitter(socket),
    sessionStateEmitter(socket),
    attendeeRosterEmitter(socket),
    programSceneLayerUpdater(setProgram),
    createdBackgroundMiddleware(),
    updateProgramLayers(),
    updateBackgroundOnProgramStartMiddleware(),
    rejectedKnockMiddleware(socket),
    streamRecordStatus(socket),
    updateSourceChangesToProgram(setProgram),
    dataDogMiddleware,
    notification,
    showAPIError,
    presentationControlNotifier(),
    sourceUpdateStatusManager(),
    toggleBackgroundHiddenMiddleware(),
    actionDebugger // this should be the last middleware
  ];

  if (getEnvVar('NODE_ENV') === 'development') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension());
    }
  }

  const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
  );

  const store = createStore(
    createRootReducer(history),
    initialState,
    composedEnhancers
  );

  socketDispatcher.bindToStore(store);

  return {
    store,
    history
  };
}

const { store, history } = createConfiguredStore();

export { store, history };

export { createConfiguredStore };
